import styled from 'styled-components'

import { Link } from '@subaio/components'

import { Title } from './Title'

export const Anchor = styled(Link)`
	opacity: 0;
	display: inline-flex;
	align-items: center;
	visibility: hidden;

	&:hover,
	${Title}:hover & {
		opacity: 1;
		visibility: visible;
	}
`
